import { reactive } from 'vue'
import ModalQueueController from '@/controllers/ModalQueueController'
import AdminController from '@/controllers/AdminController'
import CoursesController from '@/controllers/admin/CoursesController'
import MarathonController from '@/controllers/admin/MarathonController'
import CatalogController from '@/controllers/admin/CatalogController'
import PaintController from '@/controllers/admin/PaintController'
import TariffsController from '@/controllers/admin/TariffsController'
import FaqController from '@/controllers/admin/FaqController'
import OtherController from '@/controllers/admin/OtherController'
import ReviewsController from '@/controllers/admin/ReviewsController'

const store = reactive({})

export default store

export function initStore () {
  store.modalQueue = ModalQueueController()
  store.admin = AdminController()
  store.courses = CoursesController()
  store.marathon = MarathonController()
  store.catalog = CatalogController()
  store.paint = PaintController()
  store.tariffs = TariffsController()
  store.faq = FaqController()
  store.other = OtherController()
  store.reviews = ReviewsController()
}
